import { get, map } from 'lodash/fp';
import PropTypes from 'prop-types';
import React from 'react';
import { Table } from 'rsuite';
import { MemberType } from '../../../../interfaces/guest';

const { Cell } = Table;

const HouseholdMembersCell = ({ dataKey, rowData, ...props }) => {
  const householdMembers = get(dataKey, rowData);
  return (
    <Cell {...props}>
      {map(({ name }) => name, householdMembers).join(', ')}
    </Cell>
  );
};

HouseholdMembersCell.propTypes = {
  dataKey: PropTypes.string.isRequired,
  rowData: PropTypes.shape({
    othersHousehold: PropTypes.arrayOf(MemberType)
  })
};

HouseholdMembersCell.defaultProps = {
  rowData: null
};
export default HouseholdMembersCell;
